const user_tiers = {
    'free': 0,
    'pro': 1,
    'team': 2,
    'enterprise': 3,
}

export {user_tiers};